import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { ArrowRight, BookOpen, Clock, Shield, Heart } from 'lucide-react';
export function OfferSection() {
  return <section className="w-full px-6 py-24 bg-stone/20 border-t border-stone/50" data-id="element-77">
      <div className="max-w-2xl mx-auto" data-id="element-78">
        <AnimatedSection className="bg-white p-8 md:p-12 rounded-sm shadow-xl border border-stone/50 mb-16" data-id="element-79">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal text-center mb-8" data-id="element-80">
            Qué incluye (lo concreto)
          </h2>

          <div className="grid grid-cols-1 gap-6 mb-10" data-id="element-81">
            <div className="flex items-center gap-4 p-4 bg-cream rounded-sm" data-id="element-82">
              <BookOpen className="text-terracotta w-6 h-6" data-id="element-83" />
              <span className="text-charcoal font-medium" data-id="element-84">
                Ebook Duelo Libre 40+ (protocolo completo)
              </span>
            </div>
            <div className="flex items-center gap-4 p-4 bg-cream rounded-sm" data-id="element-85">
              <Clock className="text-terracotta w-6 h-6" data-id="element-86" />
              <span className="text-charcoal font-medium" data-id="element-87">
                30 días de ejercicios (12 min/día)
              </span>
            </div>
            <div className="flex items-center gap-4 p-4 bg-cream rounded-sm" data-id="element-88">
              <Heart className="text-terracotta w-6 h-6" data-id="element-89" />
              <span className="text-charcoal font-medium" data-id="element-90">
                Ritual de emergencia TR3 (10 min)
              </span>
            </div>
            <div className="flex items-center gap-4 p-4 bg-cream rounded-sm" data-id="element-91">
              <Shield className="text-terracotta w-6 h-6" data-id="element-92" />
              <span className="text-charcoal font-medium" data-id="element-93">
                Guiones de límites + Plan anti-recaída
              </span>
            </div>
          </div>

          <div className="text-center space-y-6" data-id="element-94">
            <div className="space-y-2" data-id="element-95">
              <p className="text-charcoal/60 line-through text-lg" data-id="element-96">
                Precio regular $19.99
              </p>
              <p className="text-5xl font-serif text-charcoal" data-id="element-97">$6.36</p>
              <p className="text-sm text-charcoal/60 max-w-xs mx-auto" data-id="element-98">
                No porque valga poco. Sino porque en esta etapa necesitas
                acción, no un lujo.
              </p>
            </div>

            <a id="comprar" href="https://www.renacer40.com/cart/47986651562209:1" target="_blank" rel="noopener noreferrer" onClick={() => {
            if (typeof (window as any).fbq === 'function') {
              ;
              (window as any).fbq('track', 'AddToCart', {
                content_name: 'Duelo Libre 40+',
                content_ids: ['47986651562209'],
                content_type: 'product',
                value: 6.36,
                currency: 'USD'
              });
            }
          }} className="w-full md:w-auto px-8 py-4 bg-terracotta hover:bg-terracotta-hover text-white text-lg font-medium tracking-wide rounded-sm transition-colors flex items-center justify-center gap-2 mx-auto shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200" data-id="element-99">
              <span data-id="element-100">Comprar y Empezar Hoy</span>
              <ArrowRight size={20} data-id="element-101" />
            </a>

            <p className="text-xs text-charcoal/40 mt-4" data-id="element-102">
              Pago seguro • Acceso inmediato • Formato digital
            </p>
          </div>
        </AnimatedSection>

        <AnimatedSection className="text-center max-w-lg mx-auto" data-id="element-103">
          <h3 className="text-2xl font-serif text-charcoal mb-4" data-id="element-104">
            Lo que cambia
          </h3>
          <p className="text-lg text-charcoal/80 mb-8" data-id="element-105">
            No te prometo que en 30 días "no sentirás nada". <br data-id="element-106" />
            Te prometo algo más real: <br data-id="element-107" />
            <span className="font-medium text-terracotta" data-id="element-108">
              vas a dejar de sentir que el dolor maneja tu vida.
            </span>
          </p>

          <p className="text-base text-charcoal/60 italic" data-id="element-109">
            "Este protocolo no está hecho para tus días buenos. Está hecho para
            el día que te rompes… y aun así decides no abandonarte."
          </p>
        </AnimatedSection>
      </div>
    </section>;
}